import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { List, Home } from 'lucide-react';
import verynewsLogo from '../verynews_logo.png';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();

  return (
    <motion.nav 
      className="navbar glass-effect"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="nav-logo">
            <img src={verynewsLogo} alt="VeryNews Logo" className="logo-icon" />
            <span className="logo-text gradient-text">VeryNews</span>
          </Link>
          
          <div className="nav-links">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              <Home size={18} />
              <span>Home</span>
            </Link>
            <Link 
              to="/reports" 
              className={`nav-link ${location.pathname === '/reports' ? 'active' : ''}`}
            >
              <List size={18} />
              <span>Reports</span>
            </Link>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar; 